import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/lightBizCode.js";
import Footer from "components/footers/FourColumnWithInputForm.js";
import ContactDetails from "components/cards/ThreeColBizCodeContactDetails.js";

const Address = tw.span`leading-relaxed`;
const AddressLine = tw.span`block`;
const Email = tw.span`text-sm mt-6 block text-gray-500`;
const Phone = tw.span`text-sm mt-0 block text-gray-500`;

export default () => {
  return (
    <AnimationRevealPage>
      <Header />
      {/*<ContactUsForm />*/}
      <ContactDetails
        subheading="Contáctanos"
        heading="Nuestras Oficinas"
        description="Atendemos proyectos de control de accesos, ERPs, eCommerce y domótica en Guadalajara y de forma remota en todo México."
        cards={[
          {
            title: "Sede Principal — Guadalajara, México",
            description: (
              <>
                <Address>
                  <AddressLine>Guadalajara, Jalisco</AddressLine>
                  <AddressLine>México</AddressLine>
                </Address>
                <Email>contacto@bizcodegdl.com</Email>
                <Phone>+52 (33) 2564-6932</Phone>
              </>
            )
          },
          {
            title: "Soporte Técnico — Ingeniería",
            description: (
              <>
                <Address>
                  <AddressLine>Ing. Josue Waldestran</AddressLine>
                  <AddressLine>Sr. Software Engineer</AddressLine>
                </Address>
                <Email>josue.waldestran@bizcodegdl.com</Email>
                <Phone>+52 (33) 2564-6932</Phone>
              </>
            )
          },
          {
            title: "Ventas y Propuestas Comerciales",
            description: (
              <>
                <Address>
                  <AddressLine>Ejecutivo de Ventas</AddressLine>
                  <AddressLine>BizCode GDL</AddressLine>
                </Address>
                <Email>ventas@bizcodegdl.com</Email>
                <Phone>+52 (33) 2564-6932</Phone>
              </>
            )
          },
          {
            title: "Instalación y Puesta en Marcha",
            description: (
              <>
                <Address>
                  <AddressLine>Equipo de Hardware e Instalación</AddressLine>
                  <AddressLine>Accesos, domótica y gimnasios</AddressLine>
                </Address>
                <Email>instalaciones@bizcodegdl.com</Email>
                <Phone>+52 (33) 2564-6932</Phone>
              </>
            )
          }
        ]}
      />
      <Footer />
    </AnimationRevealPage>
  );
};
